import { GenericDropdownOption } from 'App.types';
import { CampaignType } from './Projects.types';

export const projectTypeOptions: GenericDropdownOption<CampaignType>[] = [
    { value: 'creator', label: 'Creator campaigns' },
    { value: 'media', label: 'Media campaigns' },
    { value: 'microwave', label: 'Microwave campaigns' },
];
